/*
 * @Description: 
 * @Version: 
 * @Autor: houchuanfang
 * @Date: 2022-08-02 14:00:44
 * @LastEditTime: 2022-08-02 14:09:37
 */
import http from '../../plugins/utils/http'
let api = '/api'
const guidance = {
    // 就业指导列表
    workGuideList(params) {
        return http.get(`${api}/app-jycy-hebei/workGuide/list`, params)
    },
    //详情-个人
    workGuideDetail(params) {
        return http.get(`${api}/app-jycy-hebei/workGuide/detail`, params)
    },
    // 收藏
    workGuideCollect(params) {
        return http.get(`${api}/app-jycy-hebei/workGuide/collect`, params)
    },
    // 指导分类
    workGuideClassnames(params) {
        return http.get(`${api}/app-jycy-hebei/workGuide/classnames`, params)
    },
    // 我的收藏
    workGuideMylist(params) {
        return http.get(`${api}/app-jycy-hebei/workGuide/mylist`, params)
    },
    // 点赞
    workGuideZans(params) {
        return http.get(`${api}/app-jycy-hebei/workGuide/zans`, params)
    },
 
}
export default guidance